export class SupplierAlreadyInUseError extends Error {
    constructor(...params: any) {
        super(...params);
        if (params[0] && typeof params[0] === 'string') {
            // eslint-disable-next-line prefer-destructuring
            this.message = params[0];
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SupplierAlreadyInUseError);
        }

        this.name = 'SupplierAlreadyInUseError';
    }

    static fromCurrentSupplier(supplierId:string): SupplierAlreadyInUseError {
        return new SupplierAlreadyInUseError(`Supplier with id ${supplierId} is already in use`);
    }
}

export default SupplierAlreadyInUseError;
